import React from "react";
import "../../tailwind.css";
import { IDetailsCard } from "../../types/DetailsCard.types";
import Collapsible from "react-collapsible";
import { IonButton, IonSpinner } from "@ionic/react";
import classNames from "classnames";
import { StylingUtils } from "../../helpers/stylingUtils";
import { format } from "date-fns";
import { Button_Disclosure_Right_Grey, Icon_Export_Blue, Icon_Pencil } from "../../images/images";

/**
 * @description Trust background colour variants
 */
const trustBackgroundColourVariants: any = {
  SWASFT: "bg-SWASFT",
  NWAS: "bg-NWAS",
  LAS: "bg-LAS",
  NEAS: "bg-NEAS",
  YAS: "bg-YAS",
};

const DetailsCard: React.FC<IDetailsCard> = (props) => {
  return (
    <div className="flex flex-col items-center justify-center mb-[8px]">
      <div className="relative max-w-app-column w-full bg-white">
        <Collapsible
          trigger={
            <div className="bg-white">
              <div className="flex justify-between pt-4 center pl-safe-area-l pr-safe-area-r z-10 -mb-2">
                {props.trust && (
                  <div
                    className={`text-white ${
                      (props.trustBackgroundColourVariants?.[props.trust] ||
                        trustBackgroundColourVariants[props.trust]) ??
                      "bg-SWASFT"
                    } px-1 rounded-[2px] font-semibold text-13px flex justify-center items-center`}
                  >
                    {props.trust}
                  </div>
                )}
                <div />
                {props.showBetaLabel && (
                  <div className="text-white bg-black px-1 rounded-[2px] font-semibold text-13px flex justify-center items-center">
                    {"BETA"}
                  </div>
                )}
              </div>
              <div
                className={`h-[56px] relative w-full max-w-app-column flex flex-row justify-between items-center pl-safe-area-l pr-safe-area-r z-0 ${
                  props.email && "!h-[70px]"
                }`}
              >
                <div>
                  <div className="text-[17px] font-extrabold leading-normal tracking-default text-grey-80">
                    {props.name}
                  </div>
                  <div className="text-acc-11px font-medium leading-[1.27] text-grey-60">{props.email}</div>
                </div>
                <div className="text-[13px] font-semibold tracking-[-0.05px] text-cta-blue">{"View details"}</div>
              </div>
            </div>
          }
          triggerWhenOpen={
            <div className="bg-white">
              <div className="flex justify-between pt-4 center pl-safe-area-l pr-safe-area-r z-10 -mb-2">
                {props.trust && (
                  <div
                    className={`text-white ${
                      (props.trustBackgroundColourVariants?.[props.trust] ||
                        trustBackgroundColourVariants[props.trust]) ??
                      "bg-SWASFT"
                    } px-1 rounded-[2px] font-semibold text-13px flex justify-center items-center`}
                  >
                    {props.trust}
                  </div>
                )}
                <div />
                {props.showBetaLabel && (
                  <div className="text-white bg-black px-1 rounded-[2px] font-semibold text-13px flex justify-center items-center">
                    {"BETA"}
                  </div>
                )}
              </div>
              <div
                className={`h-[56px] relative w-full max-w-app-column flex flex-row justify-between items-center pl-safe-area-l pr-safe-area-r z-0 ${
                  props.email && "!h-[70px]"
                }`}
              >
                <div>
                  <div className="text-[17px] font-extrabold leading-normal tracking-default text-grey-80">
                    {props.name}
                  </div>
                  <div className="text-acc-11px font-medium leading-[1.27] text-grey-60">{props.email}</div>
                </div>
                <div className="text-[13px] font-semibold tracking-[-0.05px] text-cta-blue">{"Hide details"}</div>
              </div>
            </div>
          }
        >
          <div className="w-full max-w-app-column mb-[16px] pl-safe-area-l pr-safe-area-r bg-white">
            {props.startDate && !props.hideStartDate && (
              <div className="mb-[12px] flex flex-col">
                <div className="text-[13px] leading-[1.53] tracking-[-0.1px] text-grey-70">{"Start Date"}</div>
                <div className="text-[17px] leading-[1.53] tracking-[-0.3px] text-grey-90">
                  {format(new Date(props.startDate), "d MMM yyyy")}
                </div>
              </div>
            )}
            {props.appraisalDate && (
              <div className="mb-[12px] flex flex-col">
                <div className="text-[13px] leading-[1.53] tracking-[-0.1px] text-grey-70">{"Appraisal Date"}</div>
                <div className="text-[17px] leading-[1.53] tracking-[-0.3px] text-grey-90">
                  {format(new Date(props.appraisalDate), "d MMM yyyy")}
                </div>
              </div>
            )}
            {!props.hidePreceptors && (
              <div className="mb-[12px] flex flex-col">
                <div className="text-[13px] leading-[1.53] tracking-[-0.1px] text-grey-70">
                  {props.preceptorsText || (props.isPreceptor ? "Their Preceptor(s)" : "Your Preceptors")}
                </div>
                <div className="text-[17px] leading-[1.53] tracking-[-0.3px] text-grey-90">
                  {props.preceptors && props.preceptors.length > 0
                    ? props.preceptors.map((preceptor, index) => <div key={`${preceptor}-${index}`}>{preceptor}</div>)
                    : "None"}
                </div>
              </div>
            )}
            {props.ESRNumber && (
              <div className="mb-[12px] flex flex-col">
                <div className="text-[13px] leading-[1.53] tracking-[-0.1px] text-grey-70">{"ESR No."}</div>
                <div className="text-[17px] leading-[1.53] tracking-[-0.3px] text-grey-90">{props.ESRNumber}</div>
              </div>
            )}
            {props.region && (
              <div className="mb-[12px] flex flex-col">
                <div className="text-[13px] leading-[1.53] tracking-[-0.1px] text-grey-70">{"Region"}</div>
                <div className="text-[17px] leading-[1.53] tracking-[-0.3px] text-grey-90">{props.region}</div>
              </div>
            )}
            {props.area && (
              <div className="mb-[12px] flex flex-col">
                <div className="text-[13px] leading-[1.53] tracking-[-0.1px] text-grey-70">{"Area"}</div>
                <div className="text-[17px] leading-[1.53] tracking-[-0.3px] text-grey-90">{props.area}</div>
              </div>
            )}
            {props.team && (
              <div className="mb-[12px] flex flex-col">
                <div className="text-[13px] leading-[1.53] tracking-[-0.1px] text-grey-70">{"Team"}</div>
                <div className="text-[17px] leading-[1.53] tracking-[-0.3px] text-grey-90">{props.team}</div>
              </div>
            )}
            {props.courseID && (
              <div className="mb-[12px] flex flex-col">
                <div className="text-[13px] leading-[1.53] tracking-[-0.1px] text-grey-70">{"Course"}</div>
                <div className="text-[17px] leading-[1.53] tracking-[-0.3px] text-grey-90">{props.courseID}</div>
              </div>
            )}
            {props.roles && (
              <div className="mb-[12px] flex flex-col">
                <div className="text-[13px] leading-[1.53] tracking-[-0.1px] text-grey-70">{"Roles"}</div>
                <div className="text-[17px] leading-[1.53] tracking-[-0.3px] text-grey-90">{props.roles}</div>
              </div>
            )}
            {props.level && (
              <div className="mb-[12px] flex flex-col">
                <div className="text-[13px] leading-[1.53] tracking-[-0.1px] text-grey-70">{"Level"}</div>
                <div className="text-[17px] leading-[1.53] tracking-[-0.3px] text-grey-90">{props.level}</div>
              </div>
            )}
            {props.cohort && (
              <div className="mb-[12px] flex flex-col">
                <div className="text-[13px] leading-[1.53] tracking-[-0.1px] text-grey-70">{"Cohort"}</div>
                <div className="text-[17px] leading-[1.53] tracking-[-0.3px] text-grey-90">{props.cohort}</div>
              </div>
            )}
            <div
              className={classNames("items-center justify-center ", {
                "flex flex-row w-full gap-2": props.showExportButton && props.showEditButton,
              })}
            >
              {props.showExportButton && (
                <div
                  className={classNames("flex justify-center items-center", {
                    "flex-1 self-center": props.showEditButton,
                  })}
                >
                  <IonButton
                    className={classNames(
                      "self-center w-full h-[50px] font-bold leading-[1.5] tracking-default shrink-0 program-export-button",
                      {
                        "max-w-[358px]": !props.showEditButton,
                      }
                    )}
                    mode="ios"
                    onClick={props.exportPressed}
                  >
                    {props.isExporting ? (
                      <IonSpinner className="w-[24px] h-[24px] text-cta-blue" />
                    ) : (
                      <div className="flex items-center">
                        <img src={Icon_Export_Blue} className="size-10 img-no-select" />
                        <div className="text-[16px] font-semibold leading-default tracking-default text-center text-cta-blue">
                          {"Download"}
                        </div>
                      </div>
                    )}
                  </IonButton>
                </div>
              )}
              {props.showEditButton && (
                <div
                  className={classNames("flex justify-center items-center", {
                    "flex-1 self-center": props.showExportButton,
                  })}
                >
                  <IonButton
                    className={classNames(
                      "self-center w-full h-[50px] font-bold leading-[1.5] tracking-default shrink-0 program-export-button",
                      {
                        "max-w-[358px]": !props.showExportButton,
                      }
                    )}
                    mode="ios"
                    onClick={props.editPressed}
                  >
                    <div className="flex items-center">
                      <img src={Icon_Pencil} className="size-6 mr-1 img-no-select" />
                      <div className="text-[16px] font-semibold leading-default tracking-default text-center text-cta-blue">
                        {"Edit"}
                      </div>
                    </div>
                  </IonButton>
                </div>
              )}
            </div>
          </div>
        </Collapsible>
      </div>
      {props.showPauseInfo && (
        <div className="relative max-w-app-column w-full bg-white">
          <div className="mx-4 mb-4 px-3 pt-3 pb-1.5 bg-grey-00 border-solid border-[1px] border-[#E4E4E4] rounded-md">
            <div className="flex flex-row">
              <div className="text-acc-15px font-acc-normal text-grey-90">{"Status:"}</div>
              <div className="flex flex-row items-center ml-2 flex-shrink-0">
                {/*
              bg-orange-20
              bg-green-background
              bg-cta-red
              */}
                {props.pauseLabel && (
                  <div
                    className={classNames(
                      "flex shrink-0 items-center px-[8px] py-[2.25] justify-center h-20px rounded-[10px]",
                      StylingUtils.getPauseStatusBackgroundColor(props.pauseLabel.status)
                    )}
                  >
                    {/**
                     * text-grey-60
                     * text-orange-text
                     * text-green-text
                     * text-white
                     * text-cta-blue
                     */}
                    <div
                      className={classNames(
                        "h-[20px] leading-[20px] text-[13px] my-[2.25] font-semibold",
                        StylingUtils.getPauseStatusTextColor(props.pauseLabel.status)
                      )}
                    >
                      {props.pauseLabel.label}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="text-acc-15px font-acc-normal text-grey-90 tracking-default mt-2">
              {props.pauseDescription}
            </div>
            {props.showAbsenceConversation && (
              <div>
                <div className="h-[1px] bg-grey-30 w-full mt-3" />
                <button
                  className="flex flex-row w-full items-center justify-between py-3"
                  onClick={props.absenceConversationPressed}
                >
                  <div className="text-acc-15px font-acc-normal text-grey-90 tracking-default text-start">
                    {"Absence conversation and action plan"}
                  </div>
                  <img src={Button_Disclosure_Right_Grey} className="size-6 ml-1 img-no-select" />
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      {props.showFastTrackInfo && (
        <div className="relative max-w-app-column w-full bg-white">
          <div className="mx-4 mb-4 px-3 pt-3 pb-1.5 bg-grey-00 border-solid border-[1px] border-[#E4E4E4] rounded-md">
            <div className="flex flex-row">
              <div className="text-acc-15px font-acc-normal text-grey-90">{"Status:"}</div>
              <div className="flex flex-row items-center ml-2 flex-shrink-0">
                {/*
              bg-orange-20
              bg-green-background
              bg-cta-red
              */}
                {props.fastTrackLabel && (
                  <div
                    className={classNames(
                      "flex shrink-0 items-center px-[8px] py-[2.25] justify-center h-20px rounded-[10px]",
                      StylingUtils.getFastTrackStatusBackgroundColor(props.fastTrackLabel.status)
                    )}
                  >
                    {/**
                     * text-grey-60
                     * text-orange-text
                     * text-green-text
                     * text-white
                     * text-cta-blue
                     */}
                    <div
                      className={classNames(
                        "h-[20px] leading-[20px] text-[13px] my-[2.25] font-semibold",
                        StylingUtils.getFastTrackStatusTextColor(props.fastTrackLabel.status)
                      )}
                    >
                      {props.fastTrackLabel.label}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="text-acc-15px font-acc-normal text-grey-90 tracking-default mt-2">
              {props.fastTrackDescription ?? "All outstanding progress checks are now available to be completed"}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailsCard;
